export enum EVENT_STATUS {
  ALL = 'ALL',
  LIVE = 'LIVE',
  UPCOMING = 'UPCOMING',
  FINISHED = 'FINISHED',
  DRAFT = 'DRAFT',
}
